export default class VideoMetadata {
  constructor(spec) {
    if (spec) {
      const lContributor = spec.contributor[0].flatData;

      this.contributor = {
        bio: lContributor.bio,
        country: lContributor.country,
        discipline: lContributor.discipline.map(element => {
          return element.flatData.discipline;
        }),
        gender: lContributor.gender[0].flatData.gender,
        generation: lContributor.generation[0].flatData.generation,
        geolocation: lContributor.geolocation,
        name: lContributor.name,
      };

      this.created = spec.created;
      this.question = spec.question[0].flatData.question;
      this.longQuestion = spec.question[0].flatData.longQuestion;
      this.discipline = this.contributor.discipline;
      this.gender = this.contributor.gender;
      this.generation = this.contributor.generation;
      this.topic = spec.topic;
      this.video = spec.video[0];
      this.videoStillImage = spec.videoStillImage[0];
    }
  }
}
